import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { injectIntl } from 'react-intl';

// Style
import { Button } from 'react-bootstrap';
import Link from '../../Link';

// Translation
import { FormattedMessage } from 'react-intl';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import messages from '../../../locale/jsonMessages';
import { formatLocale, formatLocaleData } from '../../../helpers/formatLocale';
//Image
import { AddPlusIcon, GoBackArrow, RemoveIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cp from '../../../components/commonStyle.css';
import s from './EditStaticPage.css';

class EditStaticPage extends React.Component {

  constructor(props) {
    super(props)
    if (typeof window !== 'undefined') {
      this.CustomEditor = require('../../Common/Editor/CustomEditor');
    }
    this.state = { editorHtml: '' } // You can also pass a Quill Delta here

  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };


  renderQuill = ({ input, labelText, type, meta: { touched, error }, className, isRequiredInput }) => {
    const { Editor } = this.CustomEditor;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <label className='commonLabelText'>{labelText}{isRequiredInput && <sub className='isRequiredStar'>*</sub>}</label>
        <Editor {...input} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }
  renderDynamicStaticPage = ({ fields }) => {
    const { formatMessage } = this.props.intl;
    const { languages, dynamicStaticPage } = this.props;

    const activeLanguageCodes = languages?.map(item => formatLocaleData(item)) || [];
    const usedLanguages = dynamicStaticPage?.map(item => item?.language) || [];

    return (
      <div className={cp.languageBox}>
        {fields.map((item, index) => {
          const currentLanguage = fields.get(index)?.language;

          const availableLanguages = activeLanguageCodes.filter(
            locale => !usedLanguages.includes(locale) || locale === currentLanguage
          );

          const languageValue = [
            { value: '', label: formatMessage(messages.chooseLanguageLabel) },
            ...availableLanguages.map(locale => ({
              value: locale,
              label: formatLocale(locale)
            }))
          ];

          return (
            <div key={index}>
              <div className='oneColumnGrid'>
                <Field
                  name={`${item}.language`}
                  component={CommonFormComponent}
                  inputClass='commonSelectField'
                  labelText={formatMessage(messages.language)}
                  placeholder={formatMessage(messages.language)}
                >
                  {languageValue.map(lang => (
                    <option key={lang.value} value={lang.value}>{lang.label}</option>
                  ))}
                </Field>

                <Field
                  name={`${item}.metaTitle`}
                  type="text"
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.metaTitleLabel)}
                  labelText={formatMessage(messages.metaTitleLabel)}
                  inputClass='commonInputField'
                  isRequiredInput
                />
                <Field
                  name={`${item}.metaDescription`}
                  componentClass={'textarea'}
                  component={CommonFormComponent}
                  inputClass='commonTextAreaField'
                  placeholder={formatMessage(messages.metaDescriptionLabel)}
                  labelText={formatMessage(messages.metaDescriptionLabel)}
                  isRequiredInput
                />

                <Field
                  name={`${item}.content`}
                  labelText={formatMessage(messages.contentLabel)}
                  component={this.renderQuill}
                  isRequiredInput
                />
              </div>
              <div className={cx(cp.displayFlex, cp.gap16, cp.justifyContentSpaceBetween, cp.flexWrap, cp.spaceTop2, { [cp.languageBtnContainerOne]: index != 0 })}>
                <div className={cx(cp.displayFlex, cp.gap16, cp.flexWrap, cp.justifyContentFlexEnd, cp.flexGrow)}>
                  {fields.length > 1 &&
                    <Button
                      onClick={() => fields.remove(index)}
                      className={cx(cp.linkBtnPrimaryStyle, cp.displayFlex, cp.gap4, cp.alignCenter, s.addLanguageText)}
                    >
                      <RemoveIcon />
                      {formatMessage(messages.deleteLanguage)}
                    </Button>
                  }
                  {fields.length <= (languages?.length - 1) && index === fields.length - 1 &&
                    <Button
                      onClick={() => fields.push({ language: '', metaTitle: '', metaDescription: '', content: '' })}
                      className={cx(cp.linkBtnPrimaryStyle, cp.displayFlex, cp.gap4, cp.alignCenter, s.addLanguageText)}
                    >
                      <AddPlusIcon />
                      {formatMessage(messages.addLanguage)}
                    </Button>
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, title, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    if (typeof window !== 'undefined') {
      return (
        <div className='siteAdminCenterContainer'>
          <div className={cx('singleBtnFlexEnd', cp.spaceBottom4)}>
            <Link to={'/siteadmin/staticpage/management'} className='goBackLink'>
              <GoBackArrow />
              <FormattedMessage  {...messages.goBack} />
            </Link>
          </div>
          <div className='siteAdminCenterContainerBox'>
            <h1 className='siteAdminHeading'><FormattedMessage  {...messages.editPageDetails} /></h1>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{error}</strong>}
              <div className="oneColumnGrid">
                <FieldArray
                  name="dynamicStaticPage"
                  component={this.renderDynamicStaticPage}
                  rerenderOnEveryChange={true}
                />
              </div>
              <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
                <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
              </div>
            </form>
          </div>
        </div >
      );
    } else {
      return <></>;
    }
  }

}

EditStaticPage = reduxForm({
  form: 'EditStaticPage', // a unique name for this form
  validate
})(EditStaticPage);

const selector = formValueSelector('EditStaticPage');

const mapState = (state) => ({
  languages: state.runtime.isActiveLanguages,
  dynamicStaticPage: selector(state, 'dynamicStaticPage'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(EditStaticPage)));